import { State } from "components/pipeline-components/classes/state-machine/state";
import { StatesMachine } from "components/pipeline-components/classes/state-machine/state-machine";
import { RefinFields } from "components/pipeline-components/classes/parts/higienizacao/RefinPipeline";
import { DiagnosticPanel } from "./DiagnosticPanel";

export function RefinEditor({
  isDisabled,
  refinValue,
  pipelineData,
  updatePipelineData,
  selectedStateId,
  diagnosticUpdatePipelineData
}: {
  isDisabled: boolean;
  refinValue: { bancos?: string[]; convenio?: string; codigoTabela?: string };
  pipelineData?: StatesMachine;
  updatePipelineData: (
    updater: (draft: StatesMachine) => StatesMachine | void
  ) => void;
  selectedStateId?: number;
  diagnosticUpdatePipelineData?: (
    updater: (draft: StatesMachine) => StatesMachine | void
  ) => void;
}) {
  return (
    <>
      <RefinFields
        isDisabled={isDisabled}
        value={refinValue}
        mailingId={pipelineData?.idMailing}
        onChange={(newValue) => {
          updatePipelineData((draft) => {
            draft.addOperationState("REFIN");

            const executorStates = draft.states
              .filter(
                (state) =>
                  state.operation === "REFIN" && state.stateType === "EXECUTOR"
              )
              .sort((a, b) => a.id - b.id);

            const bancos = newValue.bancos ?? [];

            bancos.forEach((banco, index) => {
              const existingState = executorStates[index];

              if (existingState) {
                existingState.banco = banco;
                existingState.convenio = newValue.convenio;
                existingState.codigoTabela = newValue.codigoTabela;
                return;
              }

              const newState = new State({
                id: StatesMachine.getNextStateIdFrom(draft.states),
                operation: "REFIN",
                stateType: "EXECUTOR",
                banco,
                convenio: newValue.convenio,
                codigoTabela: newValue.codigoTabela
              });
              draft.addState(newState);
            });

            executorStates
              .slice(bancos.length)
              .forEach((state) => draft.removeState(state.id));

            return;
          });
        }}
      />
      {selectedStateId != null &&
        pipelineData &&
        diagnosticUpdatePipelineData && (
          <DiagnosticPanel
            selectedStateId={selectedStateId}
            pipelineData={pipelineData}
            operation="REFIN"
            updatePipelineData={diagnosticUpdatePipelineData}
          />
        )}
    </>
  );
}
